import { sortEmployeesWithBusByName } from './../../modules/companySettings/reviewer/util'
import { POSSIBLE_REVIEWEES_BY_REVIEWER_ID } from './Queries/Queries'
import { EmployeeWithBuFragment, PossibleRevieweesByReviewerIdQuery, PossibleRevieweesByReviewerIdQueryVariables } from '../../types'
import { client } from '../..'

export const getPossibleRevieweesByReviewerId = async (
  employeeId: string,
  companyId: string,
  callback: (employees: EmployeeWithBuFragment[]) => void,
): Promise<void> => {
  const variables = {
    employeeId,
    companyId: companyId,
  }

  const { data, errors, loading } = await client.query<PossibleRevieweesByReviewerIdQuery, PossibleRevieweesByReviewerIdQueryVariables>({
    query: POSSIBLE_REVIEWEES_BY_REVIEWER_ID,
    variables: variables,
  })
  if (!errors && !loading && data && data.possibleRevieweesByReviewerId) {
    callback(sortEmployeesWithBusByName(data.possibleRevieweesByReviewerId))
  }
}
